import { Component, AfterViewInit, ViewChild, Inject, ElementRef, Input } from '@angular/core';
import { RadiologyService } from "../service/radiology.service";
import { RadiologyDataModel, UserData, radiologyViewModel, keyvaluepair } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { ModalComponent } from "../../shared/modeldialog/index";
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";

declare var radiologyGrid: any;
declare var require: any;
@Component({
    selector: 'MentisSoft-Radiology',
    template: require('../Template/Radiology.template.html'),
    styles: [require('../Template/Radiology.css')]
})

export class RadiologyComponent implements AfterViewInit {
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _radService: RadiologyService, private _titleService: Title,
        private router: Router) {
        radiologyGrid = this;
    }

    @ViewChild("viewInstructionsModel") viewInstructionsModel: ModalComponent;
    @ViewChild("viewReportsModel") viewReportsModel: ModalComponent;
    loading = false;

    Report: any;

    dataSource: RadiologyDataModel[] = [];
    radiologyFilter: RadiologyDataModel = new RadiologyDataModel();
    columns: any[] = [];

    Instruct: string;
    doctorList: string[] = [];
    status: string[] = [];
    Date: string[] = [];
    testList: string[] = [];
    bFiltersLoaded: boolean = false;
    userName: string = "hisuser";
    password: string = "hisuser";
    AccessionNumber: string = "";

    ngAfterViewInit(): void {
        $('#overlay').hide();

        this._titleService.setTitle("Booking Reports");
        this.LoadRadiologyReports();

    }
    ViewInstructions(instruction) {

        this.LoadRadiologyInstructions(instruction);
    }
    ViewReport(ReportNo) {

        this.LoadRadiologyreports(ReportNo);
    }
    ViewResults(REPORT_NO) {
        this.LoadRadiologyResults(REPORT_NO);
    }
    onChange(event) {
        this.LoadFilterReports();
    }

    LoadFilterReports() {
        if (this.dataSource != null) {
            let radiologyFilters: keyvaluepair[] = [];

            for (var f in this.radiologyFilter) {
                if (this.radiologyFilter[f] != undefined && this.radiologyFilter[f] != null && this.radiologyFilter[f] != 'All') {
                    let kv: keyvaluepair = new keyvaluepair();
                    kv.key = f;
                    kv.value = this.radiologyFilter[f];
                    radiologyFilters.push(kv);
                }
            }
            this.buildGrid(this.getFilteredDataSource(radiologyFilters));
        }
    }

    getFilteredData(ds: RadiologyDataModel[], filter: keyvaluepair): RadiologyDataModel[] {
        let count;
        let dsFiltered: RadiologyDataModel[] = [];
        let dssubdata: radiologyViewModel[] = [];
        if (filter != null && ds != null && ds.length > 0) {
            for (let d in ds) {
                count = 0;
                if (filter.key == "TestName" || filter.key == "STATUS") {
                    for (var d1 in ds[d].radiologysSubData) {
                        for (var d2 in ds[d].radiologysSubData[d1]) {
                            if (filter.key == d2) {
                                if (filter.value == ds[d].radiologysSubData[d1][d2]) {
                                    dssubdata.push(ds[d].radiologysSubData[d1]);
                                    count++;
                                    if (count < 2) {
                                        dsFiltered.push(ds[d]);
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    for (var d1 in ds[d]) {
                        if (filter.key == d1) {
                            if (filter.value == ds[d][d1]) {
                                dsFiltered.push(ds[d]);
                            }
                        }
                    }
                }
            }
        }
        return dsFiltered;
    }
    getFilteredDataSource(filter: keyvaluepair[]): RadiologyDataModel[] {
        let ds: RadiologyDataModel[] = this.dataSource;
        if (filter != null && filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                ds = this.getFilteredData(ds, filter[i]);
            }
        }
        return ds;
    }

    public buildGrid(data) {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdRadiologyResults").data("kendoGrid");
            if (dgrid) {
                $('#grdRadiologyResults').data().kendoGrid.destroy();
                $('#grdRadiologyResults').empty();
            }
            jQuery('#grdRadiologyResults').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                scrollable: false,
                sortable: true,

                columns: this.columns,
                filterMenuInit: function (e) {
                    if (e.field != "SubmissionID" && e.field != "NameInsuredOrTreatyTitle") {
                        var filterMultiCheck = e.sender.thead.find("[data-field=" + e.field + "]").data("kendoFilterMultiCheck");
                        filterMultiCheck.container.empty();
                        var chkSourceData = filterMultiCheck.checkSource.data();

                        chkSourceData.sort(function (a: any, b: any) {
                            var sortStatus = 0;

                            if (a[e.field].toLowerCase() < b[e.field].toLowerCase()) {
                                sortStatus = -1;
                            } else if (a[e.field].toLowerCase() > b[e.field].toLowerCase()) {
                                sortStatus = 1;
                            }

                            return sortStatus;
                        });

                        filterMultiCheck.checkSource.data(chkSourceData.toJSON());
                        filterMultiCheck.createCheckBoxes();
                    }
                },

                dataBinding: this.databinding,

                dataSource: {
                    data: data,

                    pageSize: this.dataSource != null ? 10 : 0,
                    sort: [{
                        field: "ProfitCenter",
                        dir: "asc"
                    }, {
                        field: "Department",
                        dir: "asc"
                    }, {
                        field: "Modified",
                        dir: "desc"
                    }],
                },
            });
            jQuery("#grdRadiologyResults").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdRadiologyResults").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            console.log("Error while building GRid " + ex.message);
            this.handleError(ex);
        }
    }

    buildColumn(): void {

        this.columns = [
            {
                field: "DoctorName",
                title: " ",
                template: kendo.template("#=this.buildLabReportRow(RequestDate,radiologysSubData,DoctorName)#").bind(this)
            }
        ];
    }

    private handleError(error: any) {

    }

    LoadRadiologyReports() {
        this.loading = true;
        this._radService.getRadReports(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                if (p.sessionExpiry && p.SessionTimeout != "Session Expired") {
                    this.loading = false;

                    this.dataSource = p.RadiologyReports;

                    if (!this.bFiltersLoaded) {
                        this.buildFilters();
                    }
                    this.bFiltersLoaded = true;
                    this.buildGrid(this.dataSource);
                    this._SecurityService.errorMessage = "";
                }
                else {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            });
    }


    buildLabReportRow(RequestDate: string, radiologysSubData: radiologyViewModel[], DoctorName: string): string {

        var row1 = "";
        var line1 = "<div class='resultstablewrap'> <div class='visit_wrap' > <div class='doctor_date'>  <span class='dateG'> <i class='fa fa-calendar-check-o' aria- hidden='true' > </i>" + RequestDate + " </span>";
        var line2 = " <span class='pull-right'><strong>Dr.</strong>" + DoctorName + "</span ></div> ";
        var line3 = "</div > </div>";

        if (radiologysSubData && radiologysSubData.length > 0) {
            var row;
            for (var i = 0; i < radiologysSubData.length; i++) {
                var r1 = "<div class='resson_visit' > <span>Test: " + radiologysSubData[i].TestName + " | Payment:" + radiologysSubData[i].Sponsor + "</span > ";
                var r2 = "<span class='pull-right' > <span class='confirm-txt' > <i class='' aria- hidden='true' > </i>  " + radiologysSubData[i].STATUS + " </span>";
                var r3 = "<span class='pull-right' >  <span class='confirm-txt waiting-txt'> <i class='' aria-hidden='true'> </i> " + radiologysSubData[i].STATUS + " </span>";
                var r8 = "<a class='small_btn blue view_resultbtn' onclick= radiologyGrid.ViewReport('" + radiologysSubData[i].REPORT_NO + "') > <i class='fa fa-list-alt' aria- hidden='true' > </i> Report </a> ";
                var r4 = "<a class='small_btn ml5 edit_btn view_instructbtn' onclick= radiologyGrid.ViewInstructions('" + radiologysSubData[i].INSTRUCTIONS + "') > <i class='fa fa-info-circle' aria- hidden='true' > </i> Instruction</a> ";
                var r5 = "<a class='small_btn def_btn view_resultbtn' onclick=radiologyGrid.ViewResults('" + radiologysSubData[i].REPORT_NO + "')> <i class='fa fa-file-text' aria- hidden='true' > </i >  Results </a> </span > </div> ";
                var r6 = "<a class='small_btn ml5 edit_btn disableBtn view_instructbtn' >  <i class='fa fa-info-circle' aria- hidden='true' > </i>  Instruction</a> ";
                var r7 = "<a class='small_btn def_btn disableBtn view_resultbtn'> <i class='fa fa-file-text' aria- hidden='true' > </i > Results </a></span ></div> ";
                var r9 = "<a class='small_btn blue disableBtn view_resultbtn' ><i class='fa fa-list-alt' aria- hidden='true' > </i> Report </a> ";
                if (radiologysSubData[i].STATUS == "Completed" || radiologysSubData[i].STATUS == "Verified") {
                    row = r1 + r2;
                    row1 = row1.concat(row);
                }
                else {
                    row = r1 + r3;
                    row1 = row1.concat(row);
                }
                row = '';
                if (radiologysSubData[i].REPORT_NO != null && radiologysSubData[i].REPORT_NO.length != 0) {
                    row = r8;
                    row1 = row1.concat(row);
                }
                else {
                    row = r9;
                    row1 = row1.concat(row);
                }
                row = '';
                if (radiologysSubData[i].INSTRUCTIONS != null && radiologysSubData[i].INSTRUCTIONS.length != 0) {
                    row = r4;
                    row1 = row1.concat(row);
                }
                else {
                    row = r6;
                    row1 = row1.concat(row);
                }
                row = '';
                if (localStorage.getItem("HospitalName").toUpperCase() != "BSH") {
                    if (radiologysSubData[i].FILE_NAME != null && radiologysSubData[i].FILE_NAME.length != 0) {
                        row = r5;
                        row1 = row1.concat(row);
                    }
                    else {
                        row = r7;
                        row1 = row1.concat(row);
                    }
                }

            }
        }
        return line1 + line2 + row1 + line3;
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdRadiologyResults").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {

        }
    }

    LoadRadiologyInstructions(instruction) {
        var userInfo: UserData = new UserData(this._SecurityService.userId, this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.IsAdminUser);
        userInfo.InstructionId = instruction;
        this._radService.getRadiologyInstructions(userInfo)
            .subscribe(
            p => {
                if (p != null && p.SessionTimeout != "Session Expired") {
                    this.Instruct = p;

                    this.viewInstructionsModel.open();
                    this._SecurityService.errorMessage = "";
                }

                else {
                    this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                    this.router.navigate(["/Login"]);
                }
            },
            err => {
                console.log("Error while validating...");
            }

            );
    }
    click() {
    }
    LoadRadiologyResults(REPORT_NO) {
        this.loading = true;
        var userInfo: UserData = new UserData(this._SecurityService.userId, this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.IsAdminUser);

        this._radService.getRadiologyResults(REPORT_NO, userInfo)
            .subscribe(
            p => {
                if (p != null) {
                    var result = "";
                    this.AccessionNumber = REPORT_NO;
                    if (p.indexOf("Launch_Viewer.asp") >= 0) {
                        this.loading = false;
                        result = p + "AccessionNumber=" + this.AccessionNumber + "&username=" + this.userName + "&password=" + this.password;
                    }

                    else if (p.indexOf("hadicwp.hadiclinic.com") >= 0) {
                        this.loading = false;
                        result = p;
                    }
                    window.open(result, '_blank');
                }
            },
            err => {
                this.loading = false;
                console.log("Error while validating...");
            }

            );
        this.loading = false;
    }

    LoadRadiologyreports(REPORT_NO) {
        for (var i = 0; i < this.dataSource.length; i++) {
            for (var j = 0; j < this.dataSource[i].radiologysSubData.length; j++) {
                if (this.dataSource[i].radiologysSubData[j].REPORT_NO == REPORT_NO) {
                    this.Report = this.dataSource[i].radiologysSubData[j].strRadiologyTestReport;
                    this.viewReportsModel.open();
                }
            }
        }
    }
    getDistinctDoctors() {
        this.doctorList = [];
        this.doctorList.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.doctorList.indexOf(this.dataSource[i].DoctorName) == -1) {
                    this.doctorList.push(this.dataSource[i].DoctorName);
                }
            }
        }
    }
    getDistinctTestName() {
        this.testList.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                for (var j = 0; j < this.dataSource[i].radiologysSubData.length; j++) {
                    if (this.testList.indexOf(this.dataSource[i].radiologysSubData[j].TestName) == -1) {
                        this.testList.push(this.dataSource[i].radiologysSubData[j].TestName);
                    }
                }
            }
        }
    }

    getDistinctStatus() {
        this.status.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                for (var j = 0; j < this.dataSource[i].radiologysSubData.length; j++) {
                    if (this.status.indexOf(this.dataSource[i].radiologysSubData[j].STATUS) == -1) {
                        this.status.push(this.dataSource[i].radiologysSubData[j].STATUS);
                    }
                }
            }
        }
    }
    getDistinctDates() {
        this.Date.push("All");
        if (this.dataSource != null) {
            for (var i = 0; i < this.dataSource.length; i++) {
                if (this.Date.indexOf(this.dataSource[i].RequestDate) == -1) {
                    this.Date.push(this.dataSource[i].RequestDate);
                }
            }
        }
    }

    buildFilters() {
        this.getDistinctDoctors();
        this.getDistinctTestName();
        this.getDistinctStatus();
        this.getDistinctDates();
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/radiology/Component/Radiology.Component.ts